import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement } from 'react';
export function Title({ level, children }) {
    const Heading = (_a) => {
        var props = __rest(_a, []);
        return createElement(`h${level}`, props, children);
    };
    return _jsx(Heading, { children: children });
}
//# sourceMappingURL=Title.js.map